import React              from 'react';
import { makeStyles }     from '@material-ui/core/styles';

const useStyles = makeStyles (() => ({
    root: {
      width:           '100vw',
      height:          '100vh',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      flexFlow:        'column',
      backgroundColor: '#FFF',
      transition:      'opacity 1s',
    },
    iframe: {
        flex:  1,
        width: '100%'
    }
}))

type AppPageProps = {
    src:         string;
    goToAppGrid: () => void;
}

const AppPage: React.FC<AppPageProps> = ({ src, goToAppGrid }) => {

  const classes = useStyles();

  const [opacity, setOpacity] = React.useState(0)

  React.useEffect(() => {
      setTimeout(() => {
        setOpacity(1)
      }, 50)
  },[])


  React.useEffect(() => {

    const handleMessage = (evt: any) => {
      if(evt && evt.data && evt.data === "close_window"){
        console.log(`%c evt: ${ JSON.stringify(evt.data, null, 2) }`,  'color: green; font-weight: bold;')
           goToAppGrid()
       }
    }
    
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage, false); 
  }, [goToAppGrid]);   


  return (
      <div 
        className = { classes.root }
        style     = {{
            opacity: opacity
        }}
      >
        <div className = { classes.iframe }>
            <iframe 
                title           = 'Spirit_Of_Pisa'
                width           = '100%'
                height          = '100%'
                src             = { src }
                frameBorder     = '0'
                allow-scripts   = 'true'
                allowFullScreen
            />
        </div>
    </div>
       
  );
}

export default AppPage;
